import { render, staticRenderFns } from "./FeedsList.vue?vue&type=template&id=1c722092&"
import script from "./FeedsList.vue?vue&type=script&lang=js&"
export * from "./FeedsList.vue?vue&type=script&lang=js&"
import style0 from "./FeedsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports